import 'babel-polyfill';

import React from "react";
import { Button, message } from "antd";
import screenshots2 from './screenshots2'; // Import screenshot list
import axios from 'axios';
let REACT_APP_USERNAME = "18371263340"
let REACT_APP_PASSWORD = "xytechsz"
// 细胞类型中英文对照表
const CELL_TYPE_TRANSLATION = {
  'squamous': '鳞状上皮细胞',
  'squamous-lsil': '低级别鳞状上皮内病变',
  'squamous-hsil': '高级别鳞状上皮内病变',
  'squamous-asc-us': '非典型鳞状上皮细胞-意义不明确',
  'squamous-asc-h': '非典型鳞状上皮细胞-不除外高级别鳞状上皮内病变',
  'squamous-sqcac': '鳞状细胞癌',
  'Lsi1-1(团)': '成团的低级别（包括非典型鳞状、低度病变）',
  'Hsi1-1（团）': '成团的高级别（包括非典型不除外高、高度病变、癌细胞）',
  'squamous-pm-two（团）': '萎缩（成团）',
  'squamous-repair（团）': '修复（成团）',
  'b1': '线素细胞/细菌性阴道病',
  'b2': '放线菌',
  'm1': '霉菌/真菌/白色念珠菌/念珠菌',
  'm2': '孢子',
  't1': '滴虫',
  'hsv': '人类单纯疱疹病毒',
  'ascus-cell': '介于正常细胞与ASCUS之间',
  'glandular-adcae': '腺细胞异常',
  'normal': '正常',
  'glandular': '正常腺细胞',
  'r': '放疗',
  'ascus-h-cell': '介于正常与ASCUS-n之间',
  'other': '杂质',
  'em': '子宫内膜细胞'
};

// 细胞类型对应的颜色
const CELL_TYPE_COLORS = {
  'squamous': '#f022a5',
  'squamous-lsil': '#f1c40f',
  'squamous-hsil': '#e74c3c',
  'squamous-asc-us': '#9b59b6',
  'squamous-asc-h': '#e67e22',
  'squamous-sqcac': '#c0392b',
  // 其他类型颜色...
  'default': '#2ecc71'
};
class ShensikaoXB extends React.Component {
  constructor() {
    super();
    this.state = {
      screenshots2: screenshots2,
      enlargedImage: null,
      selectedScreenshot: null,
      analysisResult: null,

      highlightedCell: null, // 新增：当前高亮的细胞ID
      highlightedBox: null   // 新增：当前高亮的细胞框信息





    };
  }
  // 高亮指定细胞框的方法
  highlightCellBox = (itemIndex, cellIndex, boxIndex) => {
    const { analysisResult } = this.state;

    if (!analysisResult || !analysisResult[itemIndex] ||
      !analysisResult[itemIndex].cells[cellIndex]) {
      return;
    }

    try {
      const boxes = JSON.parse(analysisResult[itemIndex].cells[cellIndex].boxes.replace(/'/g, '"'));
      if (boxes && boxes[boxIndex]) {
        this.setState({
          highlightedBox: {
            ...boxes[boxIndex],
            type: analysisResult[itemIndex].cells[cellIndex].names,
            itemIndex,
            cellIndex,
            boxIndex
          }
        }, () => {
          // 重绘canvas以显示高亮效果
          this.drawAnnotations(this.canvasRef, analysisResult);
        });
      }
    } catch (e) {
      console.error('Error parsing cell boxes:', e);
    }
  };

  handleScreenshotClick = (screenshot) => {
    this.setState({ selectedScreenshot: screenshot, enlargedImage: screenshot, analysisResult: null });
    this.clearCanvas(this.canvasRef)
  };
  // 获取细胞类型统计的方法
  getCellTypeCounts = (analysisResult) => {
    const cellCounts = {};

    analysisResult.forEach(item => {
      if (item.cells && item.cells.length > 0) {
        item.cells.forEach(cell => {
          try {
            const boxes = JSON.parse(cell.boxes.replace(/'/g, '"'));
            const cellType = CELL_TYPE_TRANSLATION[cell.names] || cell.names;

            if (cellCounts[cellType]) {
              cellCounts[cellType] += boxes.length;
            } else {
              cellCounts[cellType] = boxes.length;
            }
          } catch (e) {
            console.error('Error parsing cell boxes:', e);
          }
        });
      }
    });

    // 转换为数组并按数量降序排序
    return Object.entries(cellCounts)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);
  };
  handleAnalyzeClick = async () => {
    if (!this.state.selectedScreenshot) {
      console.warn('No selected screenshot to analyze');
      return;
    }

    const base64Image = this.state.selectedScreenshot;
    console.log(REACT_APP_PASSWORD)

    // Basic Auth credentials
    const username = '99771a2d-f7c7-4311-a38c-eb0db8c54ff1';
    const password = '65d4e279-fbb3-4b3e-92ea-de98064d3df0';

    // API endpoint
    const url = 'https://tct.shensikao.com/api/v1/tct_dec';

    // Function to make the POST request

    try {
      // 提取 Base64 数据部分
      const base64PrefixRegex = /^data:image\/(png|jpeg|gif);base64,/;
      const match = base64Image.match(base64PrefixRegex);
      if (!match) {
        console.error('Unexpected or unsupported base64 prefix');
        return;
      }
      const imageData = base64Image.substring(match[0].length);

      const formData = new FormData();
      formData.append('imageData', imageData);
      // Configure the request options
      const config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': `Basic ${Buffer.from(`${username}:${password}`).toString('base64')}`
        }
        ,
        withCredentials: false, // 确保不使用凭证
        data: formData // Your request payload
      };

      // Send the request
     
      let getData = [
        {
          "file": "20",
          "Boclear": [],
          "cells": [
            {
              "names": "squamous",
              "boxes": "[{'x': 145.875, 'y': -0.046875, 'width': 153.75, 'height': 140.29688, 'confidence': 0.92089844}, {'x': 335.625, 'y': 106.3125, 'width': 189.0, 'height': 212.25, 'confidence': 0.91845703}, {'x': 550.5, 'y': 111.46875, 'width': 144.75, 'height': 100.78125, 'confidence': 0.26123047}, {'x': 702.75, 'y': 0.0, 'width': 166.5, 'height': 94.96875, 'confidence': 0.8671875}, {'x': 379.875, 'y': 400.875, 'width': 151.5, 'height': 102.75, 'confidence': 0.67041016}, {'x': 3.5625, 'y': 793.5, 'width': 132.84375, 'height': 133.5, 'confidence': 0.61865234}, {'x': 325.5, 'y': 581.625, 'width': 82.875, 'height': 95.25, 'confidence': 0.46899414}, {'x': 717.0, 'y': 237.0, 'width': 139.5, 'height': 154.125, 'confidence': 0.9296875}, {'x': 183.09375, 'y': 789.75, 'width': 175.40625, 'height': 136.5, 'confidence': 0.88378906}, {'x': 73.453125, 'y': 919.5, 'width': 179.29688, 'height': 160.5, 'confidence': 0.8666992}, {'x': 570.75, 'y': 515.625, 'width': 171.0, 'height': 169.5, 'confidence': 0.9404297}, {'x': 756.75, 'y': 378.75, 'width': 178.5, 'height': 203.25, 'confidence': 0.94628906}, {'x': 0.0703125, 'y': 1149.75, 'width': 93.39844, 'height': 190.5, 'confidence': 0.40551758}, {'x': 711.375, 'y': 519.75, 'width': 192.375, 'height': 169.5, 'confidence': 0.9433594}, {'x': 60.28125, 'y': 1181.25, 'width': 197.34375, 'height': 189.0, 'confidence': 0.9145508}, {'x': 415.5, 'y': 839.25, 'width': 117.75, 'height': 211.5, 'confidence': 0.93408203}, {'x': 694.125, 'y': 675.375, 'width': 190.125, 'height': 177.375, 'confidence': 0.94140625}, {'x': 30.5625, 'y': 1411.5, 'width': 145.125, 'height': 124.5, 'confidence': 0.9140625}, {'x': 252.0, 'y': 1195.5, 'width': 186.0, 'height': 181.5, 'confidence': 0.9243164}, {'x': 1362.0, 'y': 103.125, 'width': 156.0, 'height': 134.0625, 'confidence': 0.9433594}, {'x': 152.71875, 'y': 1434.0, 'width': 164.15625, 'height': 102.0, 'confidence': 0.71728516}, {'x': 1140.75, 'y': 582.0, 'width': 190.5, 'height': 180.75, 'confidence': 0.92822266}, {'x': 938.25, 'y': 798.0, 'width': 198.0, 'height': 201.0, 'confidence': 0.9589844}, {'x': 508.125, 'y': 1286.25, 'width': 96.75, 'height': 145.5, 'confidence': 0.92041016}, {'x': 410.25, 'y': 1402.5, 'width': 216.75, 'height': 133.5, 'confidence': 0.92333984}, {'x': 1338.0, 'y': 504.75, 'width': 174.0, 'height': 185.25, 'confidence': 0.9448242}, {'x': 918.0, 'y': 931.5, 'width': 115.5, 'height': 108.0, 'confidence': 0.9326172}, {'x': 654.0, 'y': 1221.0, 'width': 162.0, 'height': 139.5, 'confidence': 0.9423828}, {'x': 1846.5, 'y': 73.96875, 'width': 180.0, 'height': 118.40625, 'confidence': 0.89404297}, {'x': 1854.0, 'y': 184.96875, 'width': 114.0, 'height': 90.28125, 'confidence': 0.79003906}, {'x': 1137.0, 'y': 916.5, 'width': 150.0, 'height': 169.5, 'confidence': 0.9482422}, {'x': 1269.75, 'y': 797.25, 'width': 147.0, 'height': 145.5, 'confidence': 0.9350586}, {'x': 1743.0, 'y': 339.75, 'width': 231.0, 'height': 231.0, 'confidence': 0.9477539}, {'x': 945.0, 'y': 1275.0, 'width': 225.0, 'height': 207.0, 'confidence': 0.95947266}, {'x': 1286.25, 'y': 1079.25, 'width': 216.0, 'height': 148.5, 'confidence': 0.88427734}, {'x': 1696.5, 'y': 679.875, 'width': 189.0, 'height': 149.625, 'confidence': 0.7675781}, {'x': 1567.5, 'y': 834.0, 'width': 180.0, 'height': 196.5, 'confidence': 0.94970703}, {'x': 1489.5, 'y': 929.25, 'width': 114.0, 'height': 91.5, 'confidence': 0.92285156}, {'x': 1254.0, 'y': 1178.25, 'width': 225.0, 'height': 174.0, 'confidence': 0.9428711}, {'x': 1752.0, 'y': 767.625, 'width': 147.0, 'height': 182.625, 'confidence': 0.9526367}, {'x': 1917.0, 'y': 630.75, 'width': 129.0, 'height': 196.5, 'confidence': 0.953125}, {'x': 1557.0, 'y': 1184.25, 'width': 129.0, 'height': 196.5, 'confidence': 0.9609375}, {'x': 1930.5, 'y': 1122.0, 'width': 87.0, 'height': 148.5, 'confidence': 0.9067383}]"
            }
          ],
          "dna_cells": [],
          "Checkstage": 0,
          "image_quality": 1
        }
      ]
      // const response = getData;
      const response = await axios(config);
       
      // Handle the response
      console.log('Response:', response.data);

      // 更新状态
      this.setState(
        { analysisResult: response },
        () => message.success('图片分析完成') // 确保状态更新完成后显示成功消息
      );
    } catch (error) {
      console.error('Error during image analysis:', error.message);
      message.error('图片分析失败，请稍后再试');
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.analysisResult !== this.state.analysisResult) {
      const canvas = this.canvasRef;
      if (canvas) {
        this.drawAnnotations(canvas, this.state.analysisResult);
      }
    }
  }
  // 清除画布的方法
  clearCanvas = (canvas) => {
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  };

  drawAnnotations = (canvas, analysisResult) => {
    if (!canvas || !analysisResult) return;

    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.src = this.state.enlargedImage;

    img.onload = () => {
      const displayWidth = 750/img.naturalWidth* img.naturalWidth;
      const scaleRatioX = displayWidth / img.naturalWidth;
      const scaleRatioY = scaleRatioX;

      canvas.width = displayWidth;
      canvas.height = img.naturalHeight * scaleRatioY;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      analysisResult.forEach((item, itemIndex) => {
        if (item.cells && item.cells.length > 0) {
          item.cells.forEach((cell, cellIndex) => {
            try {
              const boxes = JSON.parse(cell.boxes.replace(/'/g, '"'));

              boxes.forEach((box, boxIndex) => {
                const x = box.x * scaleRatioX;
                const y = box.y * scaleRatioY;
                const width = box.width * scaleRatioX;
                const height = box.height * scaleRatioY;
                const uniqueId = `${itemIndex}-${cellIndex}-${boxIndex}`;

                // 判断是否是当前高亮的细胞
                const isHighlighted = this.state.highlightedCell === uniqueId;

                // 设置样式
                const cellType = cell.names;
                let color = CELL_TYPE_COLORS[cellType] || CELL_TYPE_COLORS['default'];

                if (isHighlighted) {
                  color = '#ff0000'; // 高亮颜色
                  ctx.lineWidth = 4; // 高亮边框更粗
                } else {
                  ctx.lineWidth = 2;
                }

                // 绘制矩形框
                ctx.strokeStyle = color;
                ctx.strokeRect(x, y, width, height);

                // 绘制文本
                ctx.fillStyle = color;
                ctx.font = '12px Arial';
                ctx.fillText(
                  `${CELL_TYPE_TRANSLATION[cellType] || cellType} (${(box.confidence * 100).toFixed(1)}%)`,
                  x + 5,
                  y - 5
                );
              });
            } catch (e) {
              console.error('Error parsing cell boxes:', e);
            }
          });
        }
      });
    };
  };


  render() {
    const { screenshots2, enlargedImage, analysisResult } = this.state;

    return (
      <div className="shensikao-ai-container">
        <h1 style={{ fontSize: '28px', fontWeight: '700', margin: '20px 0' }}>昕昱科技AI分析</h1>
        <hr style={{
          width: '100%',
          margin: '0 0 20px 0',
          border: 'none',
          borderTop: '1px solid #ccc',
          alignSelf: 'flex-start'
        }} />

        <div className="main-content" style={{
          display: 'flex',
          gap: '32px',
          justifyContent: 'space-between'
        }}>
          {/* Left Panel */}
          <div className="left-panel" style={{
            flex: 1,
            maxWidth: '10%',
            display: 'flex',
            flexDirection: 'column',
            height: '100vh'
          }}>
            <ul className="screenshot-list" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
              gap: '16px',
              padding: 0,
              listStyle: 'none',
              overflowY: 'auto',
              maxHeight: 'calc(100vh - 62px)',
              boxSizing: 'border-box'
            }}>
              {screenshots2.map((screenshot, index) => (
                <li key={index} onClick={() => this.handleScreenshotClick(screenshot)}
                  style={{
                    cursor: 'pointer',
                    border: '1px solid #eee',
                    borderRadius: '4px',
                    boxSizing: 'border-box'
                  }}>
                  <img
                    src={screenshot}
                    style={{
                      width: '100%',
                      height: 'auto',
                      padding: "10px",
                      objectFit: 'cover'
                    }}
                    alt={`Screenshot ${index + 1}`}
                    className="thumbnail" />
                </li>
              ))}
            </ul>
          </div>

          {/* Right Panel */}
          <div className="right-panel" style={{
            flex: 1,
            maxWidth: '900px',
            borderLeft: '1px solid #ccc',
            paddingLeft: '32px'
          }}>
            {enlargedImage && (
              <div className="enlarged-image-container">
                <div className="controls" style={{ marginBottom: '20px' }}>
                  <Button type="primary" onClick={this.handleAnalyzeClick}>AI 分析</Button>
                </div>
                <div style={{ position: 'relative', marginBottom: '20px' }}>
                  <canvas
                    ref={canvas => this.canvasRef = canvas}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      zIndex: 1
                    }}></canvas>
                  <img
                    src={enlargedImage}
                    style={{
                      width: '750px',
                      height: 'auto',

                      border: '1px solid #eee',
                      borderRadius: '4px',
                      position: 'relative',
                      zIndex: 0
                    }}
                    alt="Enlarged Screenshot"
                    className="enlarged-image" />
                </div>
              </div>
            )}
          </div>

          {/* Analysis Result Panel */}
          <div className="result-panel" style={{
            flex: 1,
            maxWidth: '20%',
            borderLeft: '1px solid #ccc',
            paddingLeft: '32px'
          }}>
            {
              analysisResult && (
                <div className="analysis-result" style={{
                  padding: '20px',
                  background: '#f5f5f5',
                  borderRadius: '4px',
                  height: '500px',
                  overflowY: 'auto',
                  display: 'flex',
                  flexDirection: 'column'

                }}>
                  <div style={{ marginBottom: '16px' }}>
                    <h3 style={{ marginTop: 0, marginBottom: '8px' }}>分析结果:</h3>
                    <div style={{ display: 'flex', gap: '20px', fontSize: '14px', color: '#666' }}>
                      <div>
                        <span style={{ fontWeight: 'bold' }}>物镜倍数: </span>
                        <span>{analysisResult[0]?.file ? `${analysisResult[0].file}倍` : '未知'}</span>
                      </div>
                      <div>
                        <span style={{ fontWeight: 'bold' }}>图片质量: </span>
                        <span style={{ color: analysisResult[0]?.image_quality === 1 ? '#52c41a' : '#f5222d' }}>
                          {analysisResult[0]?.image_quality === 1 ? '清晰' : '不清晰'}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div style={{ flex: 1, overflowY: 'auto' }}>
                    <ul style={{
                      listStyleType: 'none',
                      padding: 0,
                      margin: 0
                    }}>
                      {analysisResult.map((item, itemIndex) => (
                        item.cells.map((cell, cellIndex) => {
                          try {
                            const boxes = JSON.parse(cell.boxes.replace(/'/g, '"'));
                            return boxes.map((box, boxIndex) => {
                              const uniqueId = `${itemIndex}-${cellIndex}-${boxIndex}`;
                              return (
                                <li
                                  key={uniqueId}
                                  style={{
                                    padding: '8px',
                                    margin: '4px 0',
                                    cursor: 'pointer',
                                    backgroundColor: this.state.highlightedCell === uniqueId ? '#e6f7ff' : 'transparent',
                                    borderLeft: this.state.highlightedCell === uniqueId ? '3px solid #1890ff' : 'none'
                                  }}
                                  onClick={() => {
                                    this.setState({ highlightedCell: uniqueId });
                                    this.highlightCellBox(itemIndex, cellIndex, boxIndex);
                                  }}
                                >
                                  {`${CELL_TYPE_TRANSLATION[cell.names] || cell.names} (${(box.confidence * 100).toFixed(1)}%)`}
                                </li>
                              );
                            });
                          } catch (e) {
                            console.error('Error parsing cell boxes:', e);
                            return null;
                          }
                        })
                      ))}
                    </ul>
                  </div>

                  {/* 修改后的细胞分类统计 */}
                  <div style={{
                    marginTop: '16px',
                    paddingTop: '16px',
                    borderTop: '1px solid #e8e8e8'
                  }}>
                    <h4 style={{ marginBottom: '8px' }}>细胞分类统计:</h4>
                    <ul style={{
                      listStyleType: 'none',
                      padding: 0,
                      margin: 0,
                      fontSize: '14px'
                    }}>
                      {this.getCellTypeCounts(analysisResult).map((cellType, index) => (
                        <li key={index} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                          <span>{cellType.name}:</span>
                          <span style={{ fontWeight: 'bold' }}>{cellType.count}个</span>
                        </li>
                      ))}
                    </ul>
                    <p style={{ marginTop: '8px', fontWeight: 'bold' }}>
                      总细胞数: {analysisResult.reduce((total, item) => {
                        return total + (item.cells ? item.cells.reduce((sum, cell) => {
                          try {
                            const boxes = JSON.parse(cell.boxes.replace(/'/g, '"'));
                            return sum + boxes.length;
                          } catch (e) {
                            return sum;
                          }
                        }, 0) : 0);
                      }, 0)}
                    </p>
                  </div>
                </div>
              )
            }
          </div>

        </div>
      </div>
    );
  }
}

export default ShensikaoXB;


